import appStore from 'store';
import api from './api';
import {PAGINATION} from "../../Setting/Currency/constants";

const store = {
    namespaced: true,
    state: {
        rewardConfigDialogVisible: false,
        assetDetailDialogVisible: false,
        incomeDetailDialogVisible: false,
        poolId: -1
    },
    getters: {
        getPoolId: state => {
            return state.poolId;
        }
    },
    mutations: {
        setRewardConfigDialogVisible(state, payload) {
            state.rewardConfigDialogVisible = payload;
        },
        setAssetDetailDialogVisible(state, payload) {
            state.assetDetailDialogVisible = payload;
        },
        setIncomeDetailDialogVisible(state, payload) {
            state.incomeDetailDialogVisible = payload;
        },
        setPoolId(state, payload) {
            state.poolId = payload;
        }
    },
    actions: {}
};

appStore.registerModule('NewCoin', store);
